import classes from "./IconButton.module.css";
import {cloneElement, ReactElement, ReactNode} from "react";

type Props = {
    /**
     * Children to be rendered. Usually an icon.
     * @author Kacper Faber
     * @since 0.1.9
    */
    children?: ReactNode | ReactNode[];

    /**
     * On button is clicked
     * @author Kacper Faber
     * @since 0.1.9
    */
    onClick: () => void;

    /**
     * Size
     * @author Kacper Faber
     * @since 0.1.9
    */
    s?: 'sm'
};

/**
 * Nice button with only an icon
 * @author Kacper Faber
 * @since 0.1.9
*/
function IconButton(props: Props) {
    /**
     * Get appropriate size class basic upon size
     * @author Kacper Faber
     * @since 0.1.9
    */
    const getSizeClass = () => {
        const size = props.s ?? 'sm';

        if (size == 'sm') {
            return classes.small;
        }

        throw new Error('Invalid size, size class is not implemented');
    }

    /**
     * Get root classes
     * @author Kacper Faber
     * @since 0.1.9
    */
    const getClasses = () => {
        return `${classes.root} ${getSizeClass()}`;
    };

    return (
        <div className={getClasses()} onClick={props.onClick}>
            <div className={classes.icon}>
                { cloneElement(props.children as ReactElement, { size: '19px'}) }
            </div>
        </div>
    );
}

export default IconButton;